import React, { useState } from "react";
import "../styles.css";
import "./credit-card.css";
import ReactModal from "react-modal";
import { BoxModal } from "../../../../components/boxModal";
import { FilterButton } from "../../../../components/E-check/style";
import { useTicket } from "../../../../hooks/useTicket";


export const CreditCardModal = ({ creditCardModal, setCreditCardModal, listCards, createCard }) => {
  const [formData, setFormData] = useState({
    cardholder: "",
    PAN: "",
    ExpirityDate: "",
    CVV2: "",
  });

  function getCardBrand(cardNumber) {
    if (!cardNumber) return null;

    const number = cardNumber.replace(/\D/g, ""); // remove espaços e traços

    const brands = {
      visa: /^4[0-9]{12}(?:[0-9]{3})?$/,
      mastercard:
        /^(5[1-5][0-9]{14}|2(2[2-9][0-9]{12}|[3-6][0-9]{13}|7[01][0-9]{12}|720[0-9]{12}))$/,
      amex: /^3[47][0-9]{13}$/,
      elo: /^(4011(78|79)|431274|438935|451416|4576(31|32)|504175|627780|636297|636368|6500(31|33|51)|6504(85|86)|6507(00|01|02|03)|6509(05|06)|6516(52|53)|6550(00|01|02|03|04|05))\d*$/,
      hipercard: /^(606282\d{10}(\d{3})?|3841\d{15})$/,
      diners: /^3(0[0-5]|[68][0-9])[0-9]{11}$/,
      discover: /^6(?:011|5[0-9]{2})[0-9]{12}$/,
      jcb: /^(?:2131|1800|35\d{3})\d{11}$/,
    };

    for (const [brand, pattern] of Object.entries(brands)) {
      if (pattern.test(number)) {
        return brand;
      }
    }

    return "desconhecida";
  }

  const [isFlipped, setIsFlipped] = useState(false);

  const handleCreateCard = async () => {
    await createCard({
      cardholder: formData.cardholder,
      PAN: formData.PAN,
      ExpirityDate: formData.ExpirityDate,
      CVV2: formData.CVV2,
      brand: getCardBrand(formData.PAN),
    });
    await listCards();
    setCreditCardModal(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };


  const handleCancel = () => {
    setCreditCardModal(false);
  };

  const toggleFlip = () => setIsFlipped((prev) => !prev);

  const isFormValid = Object.values(formData).every((value) => value.trim() !== "");

  return (
    <ReactModal
      isOpen={creditCardModal}
      className="change-modal"
      overlayClassName="overlay-pix-modal"
    >
      <BoxModal
        title="Dados cartão de crédito"
        close={() => setCreditCardModal(false)}
        maxWidth={700}
      >
        <div className="credit-card-container">
          <div
            className="card-form-section"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              gap: "1rem",
            }}
          >
            {/* FORMULÁRIO */}
            <div className="card-info-form" style={{ flex: 1, marginTop: "4px" }}>
              <div className="container-row">
                <input
                  id="name"
                  className="form-control"
                  name="cardholder"
                  maxLength="29"
                  type="text"
                  placeholder="Nome impresso no cartão"
                  value={formData.cardholder}
                  onChange={handleChange}
                  required
                />

                <input
                  id="cardnumber"
                  className="form-control"
                  name="PAN"
                  style={{ marginTop: "10px" }}
                  type="text"
                  inputMode="numeric"
                  placeholder="Número do cartão"
                  value={formData.PAN}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="container-row">
                <input
                  id="expirationdate"
                  className="form-control mr-5"
                  placeholder="Validade (mm/aa)"
                  style={{ marginTop: "10px" }}
                  type="text"
                  name="ExpirityDate"
                  value={formData.ExpirityDate}
                  onChange={handleChange}
                  required
                  inputMode="numeric"
                />
                <input
                  id="securitycode"
                  className="form-control"
                  style={{ marginTop: "10px" }}
                  placeholder="CVV"
                  type="text"
                  name="CVV2"
                  value={formData.CVV2}
                  onChange={handleChange}
                  required
                  inputMode="numeric"
                />
              </div>
            </div>

            {/* CARTÃO VISUAL */}
            <div className={`credit-card ${isFlipped ? "flipped" : ""}`} onClick={toggleFlip}>
              <div className="credit-card-inner">
                {/* Frente */}
                <div className="credit-card-front">
                  <div className="card-chip" />
                  <div className="card-number">
                    {formData.PAN || "0000 0000 0000 0000"}
                  </div>
                  <div className="card-info">
                    <div>
                      <label>Nome</label>
                      <div className="cardholder">
                        {formData.cardholder || "NOME IMPRESSO"}
                      </div>
                    </div>
                    <div>
                      <label>Validade</label>
                      <div className="expiration">
                        {formData.ExpirityDate || "MM/AA"}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Verso */}
                <div className="credit-card-back">
                  <div className="magnetic-strip" />
                  <div className="signature-line">
                    <span className="signature">
                      {formData.cardholder || "NOME IMPRESSO"}
                    </span>
                    <span className="cvv">{formData.CVV2 || "000"}</span>
                  </div>
                  <div className="back-info">security code</div>
                </div>
              </div>
            </div>
          </div>

          {/* BOTÕES */}
          <div className="row mt-4 align-items-center justify-content-start btn-area">
            <div className="col-md-3 button-area">
              <FilterButton
                onClick={handleCreateCard}
                disabled={!isFormValid} // desativa se faltar algum campo
                style={{
                  opacity: isFormValid ? 1 : 0.6,
                  cursor: isFormValid ? "pointer" : "not-allowed",
                }}
              >
                Adicionar cartão
              </FilterButton>
              <button
                type="button"
                className="btn btn-secondary w-44 ml-2"
                onClick={handleCancel}
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      </BoxModal>
    </ReactModal>
  );
};
